import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const NavigationScroll = ({ children, location: { pathname } }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            try {
                window.scrollTo(0, 0);
                
                if (document.documentElement) {
                    document.documentElement.scrollTop = 0;
                }
                
                if (document.body) {
                    document.body.scrollTop = 0;
                }

                const mainContent = document.querySelector('main');
                if (mainContent) {
                    mainContent.scrollTop = 0;
                    if (mainContent.scrollTo) {
                        mainContent.scrollTo(0, 0);
                    }
                }

                const scrollableDiv = document.querySelector('.MuiBox-root');
                if (scrollableDiv && scrollableDiv.scrollHeight > window.innerHeight) {
                    scrollableDiv.scrollTop = 0;
                }

            } catch (error) {
                console.warn('Scroll error:', error);
            }
        }, 10);

        return () => clearTimeout(timer);
    }, [pathname]);

    return children || null;
};

NavigationScroll.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
};

export default withRouter(NavigationScroll);
